import React, { useEffect, useState } from "react";
import axios from "axios";
import "./App.css";

const API = "https://traweli-task-backend.onrender.com/api/tasks/";


function App() {
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState("");

  const fetchTasks = async () => {
    const res = await axios.get(API);
    setTasks(res.data);
  };

  useEffect(() => {
    fetchTasks();
  }, []);

  const addTask = async () => {
    if (!title) return;
    await axios.post(API, { title });
    setTitle("");
    fetchTasks();
  };

  const toggleTask = async (task) => {
    await axios.put(`${API}${task.id}/`, {
      ...task,
      completed: !task.completed,
    });
    fetchTasks();
  };

  const deleteTask = async (id) => {
    await axios.delete(`${API}${id}/`);
    fetchTasks();
  };

  return (
    <div className="container">
      <h1>Task Manager</h1>

      <div className="input-row">
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Add a task..."
        />
        <button onClick={addTask}>Add</button>
      </div>

      {tasks.map((task) => (
  <div key={task.id} className="task">
    <span className={task.completed ? "completed" : ""}>
      {task.title}
    </span>

    <div className="actions">
      <button onClick={() => toggleTask(task)}>
        {task.completed ? "Undo" : "Complete"}
      </button>

      <button onClick={() => deleteTask(task.id)}>
        Delete
      </button>
    </div>
  </div>
))}
    </div>
  );
}

export default App;
